

export const FINRA_DISCLOSURE_TEXT = `
<p>
    Check the background of this investment professional on 
    <a target="_blank" href="https://brokercheck.finra.org/">
    FINRA’s BrokerCheck</a>.
</p>
`;

export const THEMEDATA = [    
    {themeId:'WOMEN', cssClass:'theme-women',heroImage:'event-hero-womens.jpg', infoImage:'speaker-female.jpg'},
    {themeId:'WOMEN2', cssClass:'theme-women-pink',heroImage:'event-hero-womens-pink.jpg', infoImage:'speaker-female.jpg'},
    {themeId:'SOLAR', cssClass:'theme-solar',heroImage:'event-hero-solar.jpg', infoImage:'speaker-solar.jpg'},
    {themeId:'MORTGAGE', cssClass:'theme-mortgage',heroImage:'event-hero-mortgage.jpg', infoImage:'speaker-mortgage.jpg'},
    {themeId:'EST', cssClass:'theme-estate',heroImage:'event-hero-estate.jpg', infoImage:'speaker-estate.jpg'},
    {themeId:'STEAK', cssClass:'theme-steak',heroImage:'event-hero-steak.jpg', infoImage:'info-default.webp'},
    {themeId:'SEAFOOD', cssClass:'theme-seafood',heroImage:'event-hero-seafood.jpg', infoImage:'info-default.webp'},
    {themeId:'ITALIAN1', cssClass:'theme-italian-1',heroImage:'event-hero-italian1.jpg', infoImage:'info-default.webp'},
    {themeId:'ITALIAN2', cssClass:'theme-italian-2',heroImage:'event-hero-italian2.jpg', infoImage:'info-default.webp'},
    {themeId:'CHICKEN', cssClass:'theme-chicken',heroImage:'event-hero-chicken.jpg', infoImage:'info-default.webp'},
    {themeId:'SSD1', cssClass:'theme-ssd-1',heroImage:'event-hero-ssd1.jpg', infoImage:'speaker-ssd.jpg'},
    {themeId:'SSD2', cssClass:'theme-ssd-2',heroImage:'event-hero-ssd2.jpg', infoImage:'speaker-ssd.jpg'},
    {themeId:'CHEESEBURGER', cssClass:'theme-cheeseburger',heroImage:'event-hero-cheeseburger.jpg', infoImage:'info-default.webp'},
    {themeId:'SANDWICH', cssClass:'theme-sandwich',heroImage:'event-hero-sandwich.jpg', infoImage:'info-default.webp'},
    {themeId:'PIZZA', cssClass:'theme-pizza',heroImage:'event-hero-pizza.jpg', infoImage:'info-default.webp'},
    {themeId:'BBQCHICKEN', cssClass:'theme-bbq-chicken',heroImage:'event-hero-bbqchicken.jpg', infoImage:'info-default.webp'},
    {themeId:'HEALTH', cssClass:'theme-health',heroImage:'event-hero-health.jpg', infoImage:'speaker-health.jpg'},
    {themeId:'WEIGHT', cssClass:'theme-weight',heroImage:'event-hero-health.jpg', infoImage:'speaker-weightloss.jpg'},
    {themeId:'COGNITIVE', cssClass:'theme-cognitive',heroImage:'event-hero-health.jpg', infoImage:'speaker-cognitive.jpg'},
    {themeId:'STEM', cssClass:'theme-stem-cell',heroImage:'event-hero-stemcell.jpg', infoImage:'speaker-stemcell.jpg'},
    {themeId:'REALEST', cssClass:'theme-real-estate',heroImage:'event-hero-real-estate.jpg', infoImage:'speaker-real-estate.jpg'},
    {themeId:'MEDI', cssClass:'theme-medicare',heroImage:'event-hero-medicare.jpg', infoImage:'speaker-medicare.jpg'},
    {themeId:'TAXSTYLE', cssClass:'theme-tax-retirement',heroImage:'event-hero-tax-retirement.jpg', infoImage:'speaker-nest-egg.jpg'},
    {themeId:'RETSTYLE1', cssClass:'theme-retirement-1',heroImage:'event-hero-retirement1.jpg', infoImage:'speaker-nest-egg.jpg'},
    {themeId:'RETSTYLE2', cssClass:'theme-retirement-2',heroImage:'event-hero-retirement2.jpg', infoImage:'speaker-nest-egg.jpg'},
    {themeId:'RETSTYLE3', cssClass:'theme-retirement-3',heroImage:'event-hero-retirement2.jpg', infoImage:'speaker-beachcouple.jpg'},
    {themeId:'SPA', cssClass:'theme-spa',heroImage:'event-hero-spa.jpg', infoImage:'speaker-female.jpg'},
    {themeId:'COLLEGETHEME1', cssClass:'theme-college-building',heroImage:'event-hero-college.jpg', infoImage:'speaker-college.jpg'},
    {themeId:'COLLEGETHEME2', cssClass:'theme-college-books',heroImage:'event-hero-college-books.jpg', infoImage:'speaker-college.jpg'},
    {themeId:'GOLF', cssClass:'theme-golf',heroImage:'event-hero-golf.jpg', infoImage:'info-default.webp'},
    {themeId:'WINE', cssClass:'theme-wine',heroImage:'event-hero-wine.jpg', infoImage:'speaker-nest-egg.jpg'},
    {themeId:'APP1', cssClass:'theme-appetizer-1',heroImage:'event-hero-appetizer-1.jpg', infoImage:'info-default.webp'},
    {themeId:'APP2', cssClass:'theme-appetizer-2',heroImage:'event-hero-appetizer-2.jpg', infoImage:'info-default.webp'},
    {themeId:'MEAL', cssClass:'theme-meal',heroImage:'event-hero-meal.jpg', infoImage:'info-default.webp'},
    {themeId:'EDUCATIONAL', cssClass:'theme-educational',heroImage:'event-hero.jpg', infoImage:'info-default.webp'},
    {themeId:'SINCLAIR-PROSSER', cssClass:'theme-sinclair-prosser',heroImage:'custom-hero-sinclair-prosser.jpg', infoImage:'speaker-sinclair-prosser.jpg'},
]

export enum ImageBreak {
    EventBreak,
    ContentBreak,
    SpeakerBreak
}
export enum Language {
    English = 'EN',
    Spanish = 'ES'
}
export enum GTM {
    PHONE = 'phone'
}
export enum QAType {
    QUALIFY = 'Qualify',
    SURVEY = 'Survey',
    QUALIFY_PREFIX1 = 'gfq',
    QUALIFY_PREFIX2 = 'fq',
    SURVEY_PREFIX = 'sq-'
}

export const PostQuestIgnore = 'Is there anything in particular you’re hoping to learn about at the event?'
  
export const APP_DEFAULTS = {
    PHONE: '1-800-976-1093'
}
export const APP_IMAGE = {
    HERO:{
        DEFAULT: 'hero-default.webp'
    },
    CONTENT:{
        DEFAULT: 'info-default.webp'
    }
}

export const RELATIONSHIPS: any[] = [
    {
        relationshipIndex: 1,
        relationship: "Spouse"
    },
    {
        relationshipIndex: 2,
        relationship: "Significant Other"
    },
    {
        relationshipIndex: 7,
        relationship: "Friend"
    },
    {
        relationshipIndex: 3,
        relationship: "Parent"
    },
    {
        relationshipIndex: 4,
        relationship: "Guardian"
    },
    {
        relationshipIndex: 5,
        relationship: "Grandparent"
    },
    {
        relationshipIndex: 6,
        relationship: "Sibling"
    },
    {
        relationshipIndex: 8,
        relationship: "Son"
    },
    {
        relationshipIndex: 9,
        relationship: "Daughter"
    },
    {
        relationshipIndex: 10,
        relationship: "Co-Worker"
    },
    {
        relationshipIndex: 11,
        relationship: "Business Associate"
    },
    {
        relationshipIndex: 12,
        relationship: "Other"
    }
]


export const APP_TEXT_EN = {
    HEADER: {
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        RSVP_CODE: 'RSVP Code'
    },
    HERO: {
        PRETITLE: 'Join Us for a Complimentary Presentation',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        CTA_APPOINTMENT_TEXT: 'Can\'t make the event?',
        CTA_APPOINTMENT_BUTTON_TEXT: 'Book a one-on-one consultation'
    },
    EVENTS: {
        TITLE: 'Click an event date below to register!',
        TITLE_SINGLE: 'Click the date below to register!',
        CTA_APPOINTMENT_TEXT: 'Can\'t make the event? Book some time on my calendar.',
        CTA_APPOINTMENT_BUTTON_TEXT: 'Book a one-on-one consultation',
        ON_DEMAND_WEBINAR_TEXT: 'Join Our On-Demand Presentation',
        CLOSED_TEXT: 'We\'re sorry. All events are now closed.',
        APPOINTMENT_ONLY_TEXT: 'We\'re excited to meet with you!',
        SEATS_LIMITED_TEXT: 'Seats are limited, so hurry!',
        EVENT_FULL_TEXT: 'This event is full.',
        EVENT_PAST_TEXT: 'This event has already taken place.',
        EVENT_SEATS_LEFT_A: 'Only ',
        EVENT_SEATS_LEFT_B: ' seats left'
    },
    INFO: {
        TITLE: 'What You\'ll Learn',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        DEFAULT_BULLETS:[
            "How to maximize Social Security retirement or pension benefits",
            "Implications of the new tax reform rules on your retirement plan",
            "Tools and strategies to help you avoid outliving your nest egg",
            "Strategies for generating steady income during your retirement",
            "Taxes, fees and other potentially hidden costs of pulling money out of 401k and/or mutual fund accounts",
            "Ways to overcome mental and financial obstacles that most people face in retirement"
        ]
    },
    HOSTS: {
        TITLE: 'Featured Speakers',
        TITLE_SINGLE: 'Featured Speaker',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
    },
    FOOTER: {
        PRIVACY_POLICY_TITLE: 'Privacy Policy',
        TERMS_TITLE: 'Terms and Conditions',
        FOOTER_TEXT_1: 'RSVP.org is owned and operated by LeadingResponse, a BBB-accredited business.',
        FOOTER_TEXT_2: 'All Rights Reserved.'
    },
    FORM: {
        LABEL_FIRSTNAME: 'First Name',
        LABEL_LASTNAME: 'Last Name',
        LABEL_EMAIL: 'Preferred Email Address',
        LABEL_STREETADDRESS: 'Street Address',
        LABEL_ZIP: 'Zip Code',
        LABEL_RELATIONSHIP: 'Relationship',
        LABEL_MENUSELECTION: 'Menu Selection',
        LABEL_EMAIL_CONFIRM: 'Confirm Email Address',
        LABEL_CONTENT: 'Tell us about yourself',
        LABEL_PHONE: 'Preferred Phone Number',
        LABEL_GUESTS: 'Will you be bringing any guests?',
        LABEL_QUESTIONS: 'Tell us more about you.',
        DISCLAIMER:'By submitting your request, you grant permission for RSVP.org or their partners to contact you by phone, text messaging and/or email using the phone number or email address that you provided so we may assist you with your request for a free case evaluation and that these partners may use an automatic telephone dialing system even if the number provided is a wireless line. Being contacted is not a condition of purchase or acceptance of services of any kind.',
        LABEL_EVENTSTEXT: 'Which event would you like to attend?',
        LABEL_SINGLEEVENT: 'Reserve your seats for ',
        LABEL_GUESTNUMBER: 'Number of guests',
        LABEL_QAANSWER:'Select Answer',
        LABEL_OPTIN_QUESTION:'Would you like to receive text message reminders?'
    },
    VALIDATION:{
        REQUIRED_FIRSTNAME: 'Your first name is required',
        REQUIRED_LASTNAME: 'Your last name is required',
        REQUIRED_ADDRESS: 'Your address is required',
        REQUIRED_ZIPCODE: 'Your zip code is required',
        INVALID_ZIPCODE:'Invalid zip code',
        REQUIRED_EMAIL: 'Your email is required',
        INVALID_EMAIL: 'Emails do not match',
        REQUIRED_PHONE: 'Your phone number is required',
        REQUIRED_MENU: 'Please make a menu selection',
        REQUIRED_TEXTOPT: 'Please make a selection',
        GUESTNO_REQUIRED: 'Please select the number of guests',
        REQUIRED_GUESTFIRSTNAME: 'First name is required',
        REQUIRED_GUESTLASTNAME: 'Last name is required',
        REQUIRED_GUESTRELATION: 'Please select your guest\'s relationship to you',
        REQUIRED_GUESTMENU: 'Please make a menu selection',
        REQUIRED_MOREINFOANSWER: 'This is required',
        REQUIRED_GUESTINFOANSWER: 'This is required'
    },
    ACTION: {
        BUTTON_RESERVESEAT: 'Reserve My Seats'
    },
    MONTHS: [
        {key:'JAN', value:'January'}, {key:'FEB', value:'February'}, {key:'MAR', value:'March'}, 
        {key:'APR', value:'April'}, {key:'MAY', value:'May'}, {key:'JUN', value:'June'},
        {key:'JUL', value:'July'}, {key:'AUG', value:'August'}, {key:'SEP', value:'September'}, 
        {key:'OCT', value:'October'}, {key:'NOV', value:'November'}, {key:'DEC',value:'December'}
    ],
    DAYS : [
        {key:'SUN', value:'Sunday'}, {key:'MON', value:'Monday'}, {key:'TUE', value:'Tuesday'}, 
        {key:'WED', value:'Wednesday'}, {key:'THU',value:"Thursday"}, {key:'FRI', value:'Friday'}, 
        {key:'SAT', value:'Saturday'}
    ],
    CONFIRMATION : {Thanks:"Thank You!",
                    Registered_For:"You have been registered for:",
                    Appointment_Order: "Appointment Setting Test Order",
                    Click_Calendar: "Click below to add to your calendar",
                    Location: "Location:",
                    When: "When:",
                    Print_Confirmation: "PRINT CONFIRMATION",
                    faliureEvent_support: "1-800-555-5555"
                },
    NON_CONFIRMATION : {Sorry:"We're Sorry.",
                    Not_Qualify:"We were unable to make your reservation.",
                },
    JOB_RESERVATION_FAIL : { Title: "We’re sorry. Something went wrong.",
                            Subtitle: "Please try again later."
    }


}


export const APP_TEXT_ES = {
    HEADER: {
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        RSVP_CODE: 'RSVP Code'
    },
    HERO: {
        PRETITLE: 'Join Us for a Complimentary Presentation',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        CTA_APPOINTMENT_TEXT: 'Can\'t make the event?',
        CTA_APPOINTMENT_BUTTON_TEXT: 'Book a one-on-one consultation'
    },
    EVENTS: {
        TITLE: 'Click an event date below to register!',
        CTA_APPOINTMENT_TEXT: 'Can\'t make the event? Book some time on my calendar.',
        CTA_APPOINTMENT_BUTTON_TEXT: 'Book a one-on-one consultation',
        SEATS_LIMITED_TEXT: 'Los asientos son limitados, ¡así que date prisa!',
        EVENT_FULL_TEXT: 'Este evento está lleno',
        EVENT_PAST_TEXT: 'Este evento ya ha tenido lugar',
        EVENT_SEATS_LEFT_A: 'Solo quedan ',
        EVENT_SEATS_LEFT_B: ' asientos',
        CLOSED_TEXT: 'We\'re sorry. All events are now closed.',
    },
    INFO: {
        TITLE: 'What You\'ll Learn',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
        DEFAULT_BULLETS:[
            "How to maximize Social Security retirement or pension benefits",
            "Implications of the new tax reform rules on your retirement plan",
            "Tools and strategies to help you avoid outliving your nest egg",
            "Strategies for generating steady income during your retirement",
            "Taxes, fees and other potentially hidden costs of pulling money out of 401k and/or mutual fund accounts",
            "Ways to overcome mental and financial obstacles that most people face in retirement"
        ]
    },
    SPEAKERS: {
        TITLE: 'Featured Speakers',
        CTA_BUTTON_TEXT: 'Select a Date and Register',
        CTA_BUTTON_TEXT_SINGLE: 'Register Now!',
    },
    FOOTER: {
        PRIVACY_POLICY_TITLE: 'Política de privacidad',
        TERMS_TITLE: 'Términos y condiciones',
        FOOTER_TEXT_1: 'RSVP.org es propiedad y es operada por LeadingResponse, una empresa acreditada por la BBB.',
        FOOTER_TEXT_2: 'Todos los derechos reservados.'
    },
    FORM: {
        LABEL_FIRSTNAME: 'Nombre',
        LABEL_LASTNAME: 'Apellido',
        LABEL_EMAIL: 'Correo Electrónico Preferido',
        LABEL_STREETADDRESS: 'Dirección',
        LABEL_ZIP: 'Código Postal',
        LABEL_RELATIONSHIP: 'Relación',
        LABEL_MENUSELECTION: 'Selección de menú',
        LABEL_EMAIL_CONFIRM: 'Confirmar el correo',
        LABEL_CONTENT: 'Cuéntenos acerca de Usted.',
        LABEL_PHONE: 'Número de Teléfono Preferido',
        LABEL_GUESTS: '¿Va a traer invitados?',
        LABEL_QUESTIONS: 'Cuéntenos más sobre usted',
        DISCLAIMER:'Al enviar su solicitud, otorga permiso para que RSVP.org o sus socios se comuniquen con usted por teléfono, mensajes de texto y / o correo electrónico utilizando el número de teléfono o la dirección de correo electrónico que proporcionó para que podamos ayudarlo con su solicitud de una evaluación gratuita de su caso. y que estos socios pueden utilizar un sistema de marcación telefónica automática incluso si el número proporcionado es una línea inalámbrica. Ser contactado no es una condición para la compra o aceptación de servicios de ningún tipo.',
        LABEL_EVENTSTEXT: 'Which event would you like to attend?',
        LABEL_SINGLEEVENT: 'Reserve sus asientos para',
        LABEL_GUESTNUMBER: 'Number of guests',
        LABEL_QAANSWER:'Select Answer',
        LABEL_OPTIN_QUESTION:'Would you like to receive text message reminders?'
    },
    VALIDATION:{
        REQUIRED_FIRSTNAME: 'Su nombre es requerido',
        REQUIRED_LASTNAME: 'Su apellido es obligatorio',
        REQUIRED_ADDRESS: 'Su dirección es obligatoria',
        REQUIRED_ZIPCODE: 'Su código postal es obligatorio',
        INVALID_ZIPCODE:'Su código postal es obligatorio',
        REQUIRED_EMAIL: 'Su correo electrónico es obligatorio',
        INVALID_EMAIL: 'Emails do not match',
        REQUIRED_PHONE: 'Su número de teléfono es obligatorio',
        REQUIRED_MENU: 'Por favor haz una selección de menú',
        REQUIRED_TEXTOPT: 'Please make a selection',
        GUESTNO_REQUIRED: 'Please select the number of guests',
        REQUIRED_GUESTFIRSTNAME: 'Se requiere el primer nombre',
        REQUIRED_GUESTLASTNAME: 'El apellido es obligatorio',
        REQUIRED_GUESTRELATION: 'Please select relationship',
        REQUIRED_GUESTMENU: 'Please make a menu selection',
        REQUIRED_MOREINFOANSWER: 'The value is required',
        REQUIRED_GUESTINFOANSWER: 'The value is required'
    },
    ACTION: {
        BUTTON_RESERVESEAT: 'Reservar mis asientos'
    },
    MONTHS: [

        {key:'ENE', value:'Enero'}, {key:'FEB', value:'Febrero'}, {key:'MAR', value:'Marzo'}, 
        {key:'ABR', value:'Abril'}, {key:'MAY', value:'Mayo'}, {key:'JUN', value:'Junio'},
        {key:'JUL', value:'Julio'}, {key:'AGO', value:'Agosto'}, {key:'SEP', value:'Septiembre'}, 
        {key:'OCT', value:'Octubre'}, {key:'NOV', value:'Noviembre'}, {key:'DIC',value:'Diciembre'}

    ],
    DAYS: [
        {key:'DOM', value:'Domingo'}, {key:'LUN', value:'Lunes'}, {key:'MAR', value:'Martes'}, 
        {key:'MIE', value:'Miércoles'}, {key:'JUE',value:"Jueves"}, {key:'VIE', value:'Viernes'}, 
        {key:'SAB', value:'Sábado'}
    ],
    CONFIRMATION : {Thanks:"Thank You!",
                    Registered_For:"You have been registered for:",
                    Appointment_Order: "Appointment Setting Test Order",
                    Click_Calendar: "Click below to add to your calendar",
                    Location: "Location:",
                    When: "When:",
                    Print_Confirmation: "PRINT CONFIRMATION",
                    faliureEvent_support: "1-800-555-5555"
                },
    NON_CONFIRMATION : {Sorry:"We're Sorry.",
                    Not_Qualify:"We were unable to make your reservation.",
                },

    JOB_RESERVATION_FAIL : { Title: "We’re sorry. Something went wrong.",
                            Subtitle: "Please try again later."
    }


}